import type { Poll, PollResponse } from '@tunasong/schemas'
import { getProgress } from './progress-util.js'

export const moveChoicesToTop = (indices: number[], choices: Record<number, boolean>) => {
  const topIndices = indices.filter(idx => choices[idx])
  const bottomIndices = indices.filter(idx => !choices[idx])

  return [...topIndices, ...bottomIndices]
}

export const sortPollOptionsIndices = (
  poll: Poll,
  responses: PollResponse[],
  order: 'random' | 'desc' | 'asc' = 'random'
) => {
  if (order === 'random') {
    // Fisher-Yates shuffle algorithm
    const indices = [...Array(poll.pollOptions.length).keys()] // Create an array of indices
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[indices[i], indices[j]] = [indices[j], indices[i]] // Swap elements
    }
    return indices
  }
  const progress = poll.pollOptions.map((_, idx) => getProgress(poll, responses, idx))

  const sorted = [...poll.pollOptions]
    .sort((a, b) =>
      progress[poll.pollOptions.indexOf(a)] > progress[poll.pollOptions.indexOf(b)]
        ? 1
        : progress[poll.pollOptions.indexOf(a)] < progress[poll.pollOptions.indexOf(b)]
          ? -1
          : 0
    )
    .map(option => poll.pollOptions.indexOf(option))
  return order === 'asc' ? sorted : sorted.reverse()
}

export const sortPollOptions = (poll: Poll, responses: PollResponse[], order: 'desc' | 'asc' = 'desc') => {
  const sortedIndices = sortPollOptionsIndices(poll, responses, order)
  return sortedIndices.map(idx => poll.pollOptions[idx])
}
